import Vue from "vue";
import Vuex from "vuex";
import * as fetch from '../utils/fetch' 
import numeral from 'numeral'

// const vue = new Vue();

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        lang: "th",
        schema: {},
        calculation: [],
        formulas: [],
        assertions: [],
        companyCode: localStorage.getItem('companyCode'),
        fsData: {
            bsheet: []
        },
        activeCell: [3, 0],
        activeFsCount: 3,
        recentFiles: [],
        pdf: {},
    },
    getters: {
        companyName: state => state.fsData.entity_name,
        activeRow: state => state.activeCell[0],
        activeCol: state => state.activeCell[1],
        schemaRows: state => state.schema.length,
        fsCount: state => state.fsData.bsheet.length,
        activeBSheet: state => state.fsData.bsheet.filter(bs => bs.active),
        // list of inactive fs divided into two set, left and right
        inactiveFsList: (state) => {
            let result = { left:[], right:[] }
            let pos = 'left'
            return state.fsData.bsheet.reduce((acc, cur, index) => {
                if (cur.active) {
                    pos = 'right'
                    return acc
                } else {
                    acc[pos].push(index)
                    return acc
                }
            }, result)
        },
        // filtered schema for preview
        previewSchema: (state, getters) => {
            // let fsData = state.fsData.bsheet.filter((e, i) => i < y)
            return state.schema.filter(e => {
                // first keep all abstracted items
                // console.log(e.id)
                if (!e.parent) {
                    return true
                }
                else if (e.abstract) {
                    // check if children has value
                    const children = state.schema.filter(c => c.parent===e.id && !c.abstract)
                    return children.reduce((a, c) => {
                        return a + getters.activeBSheet.reduce((acc, fs) => {
                            return acc + numeral(fs.lineItems[c.id]).value()
                        }, 0)
                    }, 0)
                }
                else {
                    // check if we have value in those years
                    return getters.activeBSheet.reduce((acc, fs) => {
                        return acc + numeral(fs.lineItems[e.id]).value()
                    }, 0)
                }
            })
        }
    },
    mutations: {
        setSchema(state, payload) {
            state.schema = payload;
        },
        setState(state, payload) {
            state[payload.state] = payload.data
            if (payload.persist) {
                localStorage.setItem(payload.state, payload.data)
            }
        },
        setActiveCell(state, payload) {
            state.activeCell = payload
            // Vue.set(state.activeCell, payload)
        },
        setActiveRow(state, payload) {
            // check if we reach limit
            if (payload >= 0 && payload <= state.schema.length - 1) {
                state.activeCell.splice(0, 1, payload)
                // Vue.set(state.activeCell, 0, payload)
            }
        },
        setActiveCol(state, payload) {
            state.activeCell.splice(1, 1, payload)
            // Vue.set(state.activeCell, 1, payload)
        },
        removeFsItem() {
            console.log('')   
        },
        moveActiveFsWindow(state, direction) {
            let fsCount = state.fsData.bsheet.length
            let activeFsCount = state.fsData.bsheet.filter(x => x.active).length

            if (fsCount===activeFsCount) return

            // collect non-active fs index in 2 set of array
            let pos = 0
            let na = state.fsData.bsheet.reduce((acc, cur, index) => {
                if (cur.active) {
                    pos = 1
                    return acc
                } else {
                    acc[pos].push(index)
                    return acc
                }
            }, [[],[]])

            if (direction==='right') {
                // move right if we have room
                if (na[1].length) {
                    state.fsData.bsheet[na[1][0]].active = true
                    state.fsData.bsheet[na[0].length].active = false
                }
            }
            else if (direction==='left') {
                // move left if we have room
                if (na[0].length) {
                    let i = na[0].pop()
                    Vue.set(state.fsData.bsheet[i], 'active', true)
                    Vue.set(state.fsData.bsheet[i+activeFsCount], 'active', false)
                }
            }
        },
        addNewFs(state, payload) {
            state.fsData.bsheet.unshift(payload)
            // re-activate fs
            state.fsData.bsheet.forEach((fs, index, arr) => {
                arr[index].active = index < state.activeFsCount
            })
        },
        toggleLang(state) {
            state.lang = state.lang==='th' ? 'en' : 'th'
        },
        reCalculate(state, index) {
            // get active fs
            let activeFs = state.fsData.bsheet.filter(fs => fs.active)
            // calculate
            state.calculation.forEach(c => {
                var key = Object.keys(c)[0]
                var children = Object.values(c)[0]
                // use Vue.set for perfect reactivity
                Vue.set(activeFs[index].lineItems, key, children.reduce((acc, cur) => {
                    var k = Object.keys(cur)[0]
                    var weight = Object.values(cur)[0]
                    var value = Number(activeFs[index].lineItems[k]) || 0
                    return acc + (value * weight)
                }, 0))
            })
            // formula
            state.formulas.forEach(f => {
                var concept = f.concept ? f.concept.replace(':','_') : ''
                var formula = f.formula
                // build variable assignment
                var assignment = f.variables.reduce((acc, variable) => {
                    // goes through each filters
                    acc += variable.filters.reduce((acc, filter, vIndex, filters) => {
                        // var's filter type check here
                        if (filter.type==='concept') {
                            // assign current concept value first
                            var value = activeFs[index].lineItems['inra_'+filter.name.split(':')[1]] || 0
                            acc +=`var $${variable.name}=${value};\n`
                        }
                        else if (filter.type==='period') {
                            // if there is an additional of period filter,
                            // we assumed a previous period (12 months) value
                            // so we re-assign the already assign value above with
                            // the previous year value
                            // becareful when comparing two dates. timezones must be identical
                            var currentPeriodStart = new Date(activeFs[index].dateStart)
                            // note that setFullYear() returns timestamp
                            var previousPeriodStart = currentPeriodStart.setFullYear(currentPeriodStart.getFullYear()-1)
                            var previousPeriodFs = state.fsData.bsheet.filter(fs => new Date(fs.dateStart).getTime()===previousPeriodStart)
                            console.log(previousPeriodFs)
                            value = previousPeriodFs.length ? previousPeriodFs[0].lineItems['inra_'+filters[vIndex-1].name.split(':')[1]] || 0 : 0
                            acc +=`$${variable.name}=${value};\n`
                        }
                        return acc
                    },'')
                    return acc
                },'')
                // assign target concept with evaluated variable assignment and formula expression
                console.log(assignment+formula)
                var finalValue = eval(assignment+formula)
                if (concept) Vue.set(activeFs[index].lineItems, concept, finalValue)
            })
        },
        validateAssertion(state) {
            // validate each fs as some assertion may be cross period
            // so we provide full list of fs upfront
            state.fsData.bsheet.forEach((fs , index, bsheet) => {
                // clear unsatisfied items first
                Vue.set(fs, 'unsatisfied', [])
                state.assertions.forEach(a => {
                    // build variable assignment
                    var stmt = a.variables.reduce((acc, v) => {
                        // console.log(v.name, "'", acc, "'")
                        // goes through each filter
                        acc += v.filters.reduce((acc, f, fIndex) => {
                            if (f.type==='concept') {
                                var concept = f.name.replace(':','_')
                                var value = fs.lineItems[concept] ? Number(fs.lineItems[concept]).toFixed(2) : 0
                                acc += `var $${v.name}=${value};\n`
                            }
                            else if (f.type==='period') {
                                // assumed previous period (12 months)
                                var currentPeriodStart = new Date(fs.dateStart)
                                var previousPeriodStart = currentPeriodStart.setFullYear(currentPeriodStart.getFullYear()-1)
                                var previousPeriodFs = bsheet.filter(fs => new Date(fs.dateStart).getTime()===previousPeriodStart)
                                value = previousPeriodFs.length ? previousPeriodFs[0].lineItems['inra_'+f[fIndex-1].name.split(':')[1]] || 0 : 0
                                acc +=`$${v.name}=${value};\n`
                            }
                            return acc
                        }, '')
                        return acc
                    }, '')
                    // console.log('stmt:\n', stmt+a.assertion)
                    let result = eval(stmt+a.assertion)
                    // console.log('result:', result)
                    if (!result) {
                        a.variables.forEach(v => {
                            v.filters.filter(f => f.type==='concept')
                            .forEach(f => {
                                fs.unsatisfied.push({
                                    'concept': f.name.replace(':', '_'),
                                    'messages': a.messages
                                })
                            })
                        })
                        console.log('unsatisfied:', fs.unsatisfied)
                    }
                })
            })
        }
    },
    actions: {
        fetchSchema({ commit, state }) {
            // only fetch if needed
            if (Object.keys(state.schema).length === 0) {
                // vue.$axios.get("/schemas")
                // .then((response) => {
                //     commit("setSchema", response.data);
                // })
                // .catch((err) => {
                //     console.log(err);
                // });

                // try fetch
                fetch.get('/schemas')
                .then(response => {
                    commit('setSchema', response)
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        fetchFsData({ commit, state }) {
            // if (!context.state.fsData.bsheet.length || payload.force) {
                // vue.$axios.get(payload.endpoint, payload.params)
                // fetch.get(payload.endpoint)
                fetch.get('/fs-data/'+state.companyCode)
                .then(response => {
                    const payload = { state: 'fsData' }
                    payload.data = response
                    // set active fs
                    payload.data.bsheet.forEach((bs, index, arr) => {
                        arr[index].active = index < 3
                    })
                    commit('setState', payload)
                })
                .catch(err => {
                    console.log(err)
                })
            // }
        },
        fetchCalculation({ commit, state }) {
            // only fetch if needed
            if (state.calculation.length===0) {
                fetch.get('/calculation')
                .then(response => {
                    commit('setState', {
                        state: 'calculation',
                        data: response
                    })
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        fetchFormula({ commit, state }) {
            if (state.formulas.length===0) {
                fetch.get('/formula')
                .then(response => {
                    commit('setState', {
                        state: 'formulas',
                        data: response
                    })
                })
            }
        },
        fetchAssertion({ commit, state }) {
            if (state.assertions.length===0) {
                fetch.get('/assertion')
                .then(response => {
                    commit('setState', {
                        state: 'assertions',
                        data: response
                    })
                })
            }
        },
        fetchRecentFiles({ commit }) {
            // always fetch recent files list
            fetch.get('/recent')
            .then(response => {
                commit('setState', {
                    state: 'recentFiles',
                    data: response
                })
            })
        },
        fetchPdf({ commit }, code) {
            fetch.get('/pdf/'+code)
            .then(response => {
                commit('setState', {
                    state: 'pdf',
                    data: response
                })
            })
        },
        setActiveCell({ commit }, payload) {
            commit('setActiveCell', payload)
        },
        setActiveRow({ commit }, payload) {
            commit('setActiveRow', payload)
        },
        setActiveCol({ commit }, payload) {
            commit('setActiveCol', payload)
        },
        removeFsItem({ commit }, payload) {
            commit('removeFsItem', payload)
        },
        moveActiveFsWindow({ commit }, direction) {
            commit('moveActiveFsWindow', direction)
        },
        addNewFs({ commit }, payload) {
            commit('addNewFs', payload)
        },
        toggleLang({ commit }) {
            commit('toggleLang')
        },
        reCalculate({ commit }, index) {
            commit('reCalculate', index)
        },
        validateAssertion({ commit }) {
            commit('validateAssertion')
        },
        saveFsData({ state }) {
            fetch.post('/update-fs-data', state.fsData)
            .then(response => {
                console.log(response)
            })
        },
        setCompanyCode({ commit }, companyCode) {
            commit('setState', {
                state: 'companyCode',
                data: companyCode,
                persist: true,
            })
            // fetch pdf list when
            commit('fetchPdf', companyCode)
        }
    },
    modules: {},
});
